import React, { useState } from "react";
import api from "../../lib/api";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { toast } from "sonner";
import { BellRing, Check } from "lucide-react";

export const NotifyMe = ({ productId }) => {
  const [nom, setNom] = useState("");
  const [tel, setTel] = useState("");
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (tel.replace(/\D/g, "").length < 8) { toast.error("Indiquez un numéro WhatsApp valide"); return; }
    setSending(true);
    try {
      await api.post(`/products/${productId}/alerte`, { telephone: tel, nom });
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur, réessayez");
    } finally {
      setSending(false);
    }
  };

  if (done) {
    return (
      <div className="mt-4 flex items-center gap-2 rounded-xl bg-[#E8F8EE] p-4 text-sm text-[#1da851]" data-testid="notify-success">
        <Check className="h-4 w-4" /> C'est noté ! Nous vous écrirons sur WhatsApp dès qu'une pièce similaire arrive.
      </div>
    );
  }
  return (
    <form onSubmit={submit} className="mt-4 rounded-xl bg-[#F6E4DE] p-4" data-testid="notify-form">
      <p className="flex items-center gap-2 font-medium text-[#2C1A14]"><BellRing className="h-4 w-4 text-[#D76E4D]" /> Prévenez-moi d'une pièce similaire</p>
      <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
        <Input value={nom} onChange={(e) => setNom(e.target.value)} placeholder="Prénom" data-testid="notify-nom" className="bg-white" />
        <Input value={tel} onChange={(e) => setTel(e.target.value)} placeholder="WhatsApp : 07 00 00 00 00" inputMode="tel" data-testid="notify-tel" className="bg-white" />
      </div>
      <Button type="submit" disabled={sending} data-testid="notify-submit" className="mt-3 w-full rounded-full bg-[#2C1A14] text-white hover:bg-[#D76E4D]">
        {sending ? "Envoi..." : "Me prévenir sur WhatsApp"}
      </Button>
    </form>
  );
};
